import { Link } from "react-router-dom";
import { path } from "../../routing/helpers/router";
import styled from "styled-components";
import { AppRemixIcon } from "@/layout/AppComponents";

const SidebarButton = (props) => {
  const { href, icon, title, old, accordion, active } = props;

  if (href)
    return (
      <Link
        to={old ? { pathname: href } : path(href)}
        target={old ? "_parent" : "_self"}
        title={title}
        className={!icon ? "sub-element" : ""}
        style={active ? { background: "#eeeeee" } : {}}
      >
        <span className="sidebar-element">
          {icon && <AppRemixIcon icon={icon} className="sidebar-icon" />}
          <span className="sb-title">{title}</span>
        </span>
      </Link>
    );

  return (
    <div className="link-a pointer">
      {icon && <span className="sidebar-icon">{icon}</span>}
      <span className="sb-title">{title}</span>{" "}
      {accordion && (
        <AppRemixIcon
          icon="arrow-drop-down"
          size={20}
          className="float-right sb-dropdown-icon"
        />
      )}
    </div>
  );
};

export default SidebarButton;

const Container = styled.div``;
